import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from "./Redux/store";

// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';

// Import local styles
import './assets/styles/main.css';
import './assets/styles/conventional.css';
import Notification from "./Components/Notification/Notification";
import "react-quill/dist/quill.snow.css";
import "./chartjs-setup";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <React.StrictMode>
        <BrowserRouter>
          <Notification />
          <App />
        </BrowserRouter>
      </React.StrictMode>
    </PersistGate>
  </Provider>
);
